"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_utilities_1 = require("@syl-editor/core-utilities");
var Editor_1 = require("@syl-editor/lib/dist/lib/Editor");
var renderer_1 = require("@syl-editor/lib/dist/lib/renderer");
var utils_1 = require("./modules/utils");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var SylEditor = /** @class */ (function (_super) {
    __extends(SylEditor, _super);
    function SylEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mountDOM = react_1.default.createRef();
        _this.editor = null;
        return _this;
    }
    SylEditor.prototype.componentDidMount = function () {
        if (!this.editor && this.mountDOM && this.mountDOM.current) {
            this.setConfig(this.props.config);
            this.editor = Editor_1.SylEditorService.init(this.mountDOM.current, this.props.config, this.props);
            if (this.props.disable)
                this.editor.disable();
            this.props.getAdapter && this.props.getAdapter(this.editor);
        }
    };
    SylEditor.prototype.setConfig = function (config) {
        if (config && config.Modules) {
            Object.keys(config.Modules).forEach(function (key) {
                if (!config.Modules[key].option)
                    return;
                var defaultOption = utils_1.moduleOption[key] || utils_1.moduleOption.default;
                config.Modules[key].option = __assign(__assign({}, defaultOption), config.Modules[key].option);
            });
        }
    };
    SylEditor.prototype.shouldComponentUpdate = function (nextProps) {
        if (!this.editor || this.editor.isDestroy)
            return true;
        if (Editor_1.SylEditorService.hasEventUpdate(this.props, nextProps)) {
            Editor_1.SylEditorService.mountEvent(this.editor, nextProps, this.props);
        }
        Editor_1.SylEditorService.hasConfigUpdate(this.props, nextProps, this.editor);
        if (nextProps.disable !== this.props.disable) {
            !nextProps.disable ? this.editor.enable() : this.editor.disable();
        }
        if (nextProps.locale !== this.props.locale) {
            this.editor.configurator.setLocale(nextProps.locale);
        }
        this.updateModules(nextProps.config.Modules, this.props.config.Modules);
        return true;
    };
    SylEditor.prototype.updateModules = function (nextModules, curModules) {
        if (!nextModules || !curModules)
            return;
        if (this.editor && this.editor.configurator.modules) {
            var moduleInstances_1 = this.editor.configurator.modules.cache;
            Object.keys(nextModules).forEach(function (key) {
                var nOption = nextModules[key].option;
                var cOption = curModules[key].option;
                if (!nOption || !cOption)
                    return;
                if (!lodash_isequal_1.default(nOption, cOption)) {
                    var instance = moduleInstances_1[key];
                    instance && instance.setProps({ option: __assign({}, nOption) });
                }
            });
        }
    };
    SylEditor.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "syl-editor", ref: this.mountDOM, style: { position: 'relative' } }));
    };
    SylEditor.prototype.componentWillUnmount = function () {
        if (this.editor) {
            this.editor.uninstall();
            renderer_1.rendererGlobalCache.remove(this.editor);
        }
    };
    return SylEditor;
}(react_1.default.Component));
exports.SylEditor = SylEditor;
(function (SylEditor) {
    SylEditor.defaultProps = {
        onBlur: core_utilities_1.Types.noop,
        onFocus: core_utilities_1.Types.noop,
        disable: false
    };
})(SylEditor = exports.SylEditor || (exports.SylEditor = {}));
exports.SylEditor = SylEditor;
//# sourceMappingURL=Editor.js.map